
<template>

  <el-button @click="$refs.recycleSetting.call(element,data)" icon="Filter" link type="primary" size="small">字段设置</el-button>


  <recycle-setting ref="recycleSetting"></recycle-setting>

</template>

<script>
import recycleSetting from "@/components/etl/node/recycle/recycleSetting.vue";
export default {
  components:{
    recycleSetting
  },
  props: {
    data: {
      type: Object,
      default: () => {
      }
    },
    element: {
      type: Object,
      default: () => {
      }
    }
  },




}

</script>


<style scoped lang="scss">

</style>